"use client";
import { jsxs as l, jsx as r } from "react/jsx-runtime";
const d = ({
  title: e,
  titleId: i,
  desc: n,
  descId: o,
  ...t
}) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": i,
    "aria-describedby": o,
    ...t,
    children: [
      n ? /* @__PURE__ */ r("desc", { id: o, children: n }) : null,
      e ? /* @__PURE__ */ r("title", { id: i, children: e }) : null,
      /* @__PURE__ */ r(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "M12 2v2m0 16v2M4 12H2m4.3141-5.6859L4.9 4.9m12.786 1.4142L19.1001 4.9M6.3141 17.69 4.9 19.1042m12.786-1.4142 1.4142 1.4142M22 12h-2m-3 0c0 2.7614-2.2386 5-5 5s-5-2.2386-5-5 2.2386-5 5-5 5 2.2386 5 5"
        }
      )
    ]
  }
);
export {
  d as default
};
//# sourceMappingURL=MorningIcon.js.map
